/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Alter_Size_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot save: tables must seat 4 or 5 players." |
*
* @param {Rounds_Alter_Size_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_alter_size_error = /** @type {((inputs?: Rounds_Alter_Size_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Alter_Size_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer : les tables doivent accueillir 4 ou 5 joueurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede guardar: las mesas deben tener 4 o 5 jugadores.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível salvar: as mesas devem ter 4 ou 5 jogadores.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare: i tavoli devono avere 4 o 5 giocatori.")
	return /** @type {LocalizedString} */ ("Cannot save: tables must seat 4 or 5 players.")
});